import Component from './abstract_component';
import $ from 'jquery';

class FamilySubscriptions extends Component {
  constructor(uniqueSelector) {
    super();
    this.subscriptionsBlock = $(uniqueSelector);
  }

  _isReady() {
    return !!this.subscriptionsBlock.length;
  }

  _loadView() {
    if (this.requests.length) {
      this.requests.forEach(request => request.abort());
    }
    this.requests = [];
    this.options.each((index, option) => {

      const nid = option.getAttribute("data-id");
      this.subscriptionsBlock.append('<div class="ajax-progress ajax-progress-fullscreen"></div>');

      this.requests.push($.ajax({
        url: `/api/blocks/template/family-subscriptions-option?nid=${nid}&members=${this.members}`,
        type: 'GET',
        dataType: 'json'
      }));
    });

    this.requests.push($.ajax({
      url: `/api/blocks/template/family-subscriptions-product?nid=${this.selectedNodeId}&members=${this.members}`,
      type: 'GET',
      dataType: 'json'
    }));

    $.when(...this.requests)
      .done((...responses) => {
        const productResponse = responses.pop();
        const productData = productResponse?.length ? productResponse[0]?.block : '';

        this.product.html(productData);

        responses.forEach((response, index) => {
          this.optionButtons.eq(index).html(response[0].block)
        })
        this.subscriptionsBlock.find('.ajax-progress').remove();
        this.counter.text(this.members);

        if (this.members === this.constants.MIN_MEMBERS) {
          this.lessButton.addClass('is-disabled');
        }
        if (this.members === this.constants.MAX_MEMBERS) {
          this.moreButton.addClass('is-disabled');
        }
        if (this.members > this.constants.MIN_MEMBERS) {
          this.lessButton.removeClass('is-disabled');
        }
        if (this.members < this.constants.MAX_MEMBERS) {
          this.moreButton.removeClass('is-disabled');
        }
      }).fail((status, error) => {
      if (status !== 'abort') {
        console.error("Error: " + error);
      }
    });
  }

  _events() {
    this.lessButton.on('click', () => {
      if (this.members === this.constants.MIN_MEMBERS) {
        return;
      }
      --this.members;
      this._loadView();
    });

    this.moreButton.on('click', () => {
      if (this.members === this.constants.MAX_MEMBERS) {
        return;
      }
      ++this.members;
      this._loadView();
    });

    this.optionButtons.on('click', (e) => {
      const thisOption = e.target.closest('article');
      this.selectedNodeId = thisOption.getAttribute('data-id');
      this.options.removeClass('is-selected');
      thisOption.classList.add('is-selected');
      this._loadView();
    });
  }

  _run() {

    this.constants = {
      MIN_MEMBERS: 2,
      MAX_MEMBERS: 6,
    }

    this.options = this.subscriptionsBlock.find('.js-options article');
    this.optionButtons = this.subscriptionsBlock.find('.js-options button');
    this.product = this.subscriptionsBlock.find('.js-product');
    this.lessButton = this.subscriptionsBlock.find('.js-less');
    this.moreButton = this.subscriptionsBlock.find('.js-more');
    this.counter = this.subscriptionsBlock.find('.js-counter');
    this.members = this.constants.MIN_MEMBERS;
    this.requests = [];

    const firstOption = this.options.first();
    firstOption.addClass('is-selected');
    this.selectedNodeId = firstOption.data('id');

    this._events();
  }
}


export default FamilySubscriptions;
